import React, { useEffect, useState } from "react";
import FirebaseService from "./FirebaseService";
import "./LeadsDashboard.css";

const formatCreatedAt = (createdAt) => {
  if (!createdAt) return "Pending server timestamp";
  if (typeof createdAt.toDate === "function") {
    return createdAt.toDate().toLocaleString();
  }
  return String(createdAt);
};

const LeadsDashboard = () => {
  const [leads, setLeads] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [viewMode, setViewMode] = useState("list");
  const [selectedLead, setSelectedLead] = useState(null);

  useEffect(() => {
    const unsubscribe = FirebaseService.subscribeHireLeads(
      (nextLeads) => {
        setLeads(nextLeads);
        setIsLoading(false);
      },
      (err) => {
        setError(err.message || "Unable to load leads.");
        setIsLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return (
    <div className="leads-page">
      <header className="leads-header">
        <h1>Hire Leads</h1>
        <p>Total Leads: {leads.length}</p>
        <div className="view-toggle" role="tablist" aria-label="Leads view mode">
          <button
            type="button"
            className={viewMode === "list" ? "toggle-btn active" : "toggle-btn"}
            onClick={() => setViewMode("list")}
          >
            List View
          </button>
          <button
            type="button"
            className={viewMode === "tiles" ? "toggle-btn active" : "toggle-btn"}
            onClick={() => setViewMode("tiles")}
          >
            Tiles View
          </button>
        </div>
      </header>

      {isLoading && <p className="leads-status">Loading leads...</p>}
      {error && <p className="leads-status leads-error">{error}</p>}

      {!isLoading && !error && leads.length === 0 && (
        <p className="leads-status">No leads yet.</p>
      )}

      {!isLoading && !error && leads.length > 0 && viewMode === "tiles" && (
        <div className="leads-grid">
          {leads.map((lead) => (
            <article key={lead.id} className="lead-card">
              <h2>{lead.name || "No name"}</h2>
              <p><strong>Email:</strong> {lead.email || "-"}</p>
              <p><strong>Project Type:</strong> {lead.projectType || "-"}</p>
              <p><strong>Budget:</strong> {lead.budget || "-"}</p>
              <p><strong>Timeline:</strong> {lead.timeline || "-"}</p>
              <p><strong>Source:</strong> {lead.source || "-"}</p>
              <p><strong>Received:</strong> {formatCreatedAt(lead.createdAt)}</p>
              <p className="lead-message">{lead.message || "-"}</p>
            </article>
          ))}
        </div>
      )}

      {!isLoading && !error && leads.length > 0 && viewMode === "list" && (
        <div className="leads-list">
          <div className="leads-list-header">
            <span>Name</span>
            <span>Email</span>
            <span>Budget</span>
          </div>
          {leads.map((lead) => (
            <button
              key={lead.id}
              type="button"
              className="leads-list-row"
              onClick={() => setSelectedLead(lead)}
            >
              <span>{lead.name || "No name"}</span>
              <span>{lead.email || "-"}</span>
              <span>{lead.budget || "-"}</span>
            </button>
          ))}
        </div>
      )}

      {selectedLead && (
        <div
          className="lead-modal-overlay"
          role="dialog"
          aria-modal="true"
          aria-labelledby="lead-modal-title"
          onClick={() => setSelectedLead(null)}
        >
          <div className="lead-modal-card" onClick={(event) => event.stopPropagation()}>
            <div className="lead-modal-header">
              <h2 id="lead-modal-title">{selectedLead.name || "Lead details"}</h2>
              <button
                type="button"
                className="lead-modal-close"
                aria-label="Close lead details"
                onClick={() => setSelectedLead(null)}
              >
                x
              </button>
            </div>
            <p><strong>Email:</strong> {selectedLead.email || "-"}</p>
            <p><strong>Project Type:</strong> {selectedLead.projectType || "-"}</p>
            <p><strong>Budget:</strong> {selectedLead.budget || "-"}</p>
            <p><strong>Timeline:</strong> {selectedLead.timeline || "-"}</p>
            <p><strong>Source:</strong> {selectedLead.source || "-"}</p>
            <p><strong>Received:</strong> {formatCreatedAt(selectedLead.createdAt)}</p>
            <p className="lead-message">{selectedLead.message || "-"}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default LeadsDashboard;
